import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';

export function addWorkItemPresetPart(data, errorType) {
	return dispatch => Api.postData('work_item_preset_parts/', data).then(() => dispatch(getInfo.getWorkItemPresets())).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateWorkItemPresetPart(id, data, errorType) {
	return dispatch => Api.patchData(`work_item_preset_parts/${id}`, data).then(() => dispatch(getInfo.getWorkItemPresets())).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteWorkItemPresetPart(id, errorType) {
	return dispatch => Api.delete(`work_item_preset_parts/${id}`).then(() => dispatch(getInfo.getWorkItemPresets())).catch(ex => Api.handleApiError(ex, errorType));
}
